module.exports = __webpack_public_path__ + "static/media/Business accounts - SD (3).ef5d7f24.jpg";